/** @graphql agg **/
import gql from 'graphql-tag';

import { getAGGClient } from '@confluence/graphql';

import {
	type FetchPresenceAGGUsersQuery as UsersQuery$data,
	type FetchPresenceAGGUsersQueryVariables as UsersQuery$variables,
} from './__types__/FetchPresenceAGGUsersQuery';

export const fetchPresenceAGGUsers = (accountIds: string[]) => {
	return getAGGClient()
		.query<UsersQuery$data, UsersQuery$variables>({
			query: gql`
				query fetchPresenceAGGUsersQuery($accountIds: [ID!]!) {
					users(accountIds: $accountIds) {
						accountId
						name
						picture
					}
				}
			`,
			variables: { accountIds },
		})
		.then(({ data }) => {
			return (
				data?.users
					?.filter((user) => user?.accountId)
					.map((user) => ({
						avatar: user.picture ?? '',
						email: '',
						name: user.name ?? '',
						userId: user.accountId || '',
					})) ?? []
			);
		});
};
